import React, { Component } from 'react'

import './style.scss'
import Select from 'react-select'

export default class BlogSearch extends Component {
  constructor(props) {
    super(props)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.onTagChange = this.onTagChange.bind(this)
    this.reset = this.reset.bind(this)
  }

  defaultValue = { value: 'all', label: 'All categories' }

  searchRef = null

  state = {
    tagValue: this.defaultValue,
  }

  reset() {
    this.searchRef.value = ''
    this.setState({ tagValue: this.defaultValue })
    this.props.updateResults({})
  }

  onTagChange(tagValue) {
    this.setState({ tagValue }, this.onSearchChange)
  }

  onSearchChange() {
    this.props.updateResults({
      query: this.searchRef.value,
      tag: this.state.tagValue.value,
    })
  }

  render() {
    const { hasSearched, tags } = this.props
    return (
      <div>
        {hasSearched && (
          <div
            className={`c-search-box-info mb-3 text-mid font-weight-bold ${
              hasSearched ? 'visible' : 'invible'
            }`}
          >
            Didn't find what you're looking for?{' '}
            <button
              className="c-search-box-info__reset text-secondary"
              onClick={this.reset}
            >
              <u>Show all posts</u>
            </button>
          </div>
        )}
        <div className="d-sm-flex">
          <div
            onClick={() => this.searchRef.focus()}
            className="c-search-box c-search-box--icon bg-white shadow p-1 mr-sm-3 mb-1 mb-sm-0 w-100"
          >
            <div className="c-search-box__inner">
              <label htmlFor="blog-search">Search by keywords</label>
              <input
                ref={ref => (this.searchRef = ref)}
                onChange={this.onSearchChange}
                type="text"
                id="blog-search"
                placeholder="Keyword"
              />
            </div>
          </div>
          <div className="c-search-box bg-white shadow py-1 px-2 w-100">
            <div className="c-search-box__inner">
              <label htmlFor="blog-search">Choose category</label>
              <Select
                className="c-custom-select"
                classNamePrefix="c-custom-select"
                onChange={this.onTagChange}
                name="blog-category"
                id="blog-category"
                isSearchable={false}
                value={this.state.tagValue}
                options={[
                  this.defaultValue,
                  ...tags.map(tag => ({ value: tag, label: tag })),
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
